const SELECTORS = {
    container: '.js--tabs',
    tab: '[role="tab"]',
    panel: '[role="tabpanel"]',
};
const INIT_ATTR = 'data-tabs-init';
const FADE_MS = 250;
const EASING = 'ease';
const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const resolveContainers = (scope) => {
    if (typeof scope === 'string') {
        return Array.from(document.querySelectorAll(scope));
    }
    if (Array.isArray(scope)) {
        return scope;
    }
    if (scope instanceof NodeList) {
        return Array.from(scope);
    }
    return Array.from(scope.querySelectorAll(SELECTORS.container));
};
const fadeIn = (panel) => {
    if (reducedMotion())
        return;
    panel.style.transition = 'none';
    panel.style.opacity = '0';
    panel.style.willChange = 'opacity';
    panel.offsetHeight;
    panel.style.transition = `opacity ${FADE_MS}ms ${EASING}`;
    panel.style.opacity = '1';
    const cleanup = (e) => {
        if (e.propertyName !== 'opacity')
            return;
        panel.removeEventListener('transitionend', cleanup);
        panel.style.transition = '';
        panel.style.willChange = '';
        panel.style.opacity = '';
    };
    panel.addEventListener('transitionend', cleanup);
};
const activateTab = (tab, tabs, panels) => {
    const targetId = tab.getAttribute('aria-controls');
    tabs.forEach((t) => {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
    });
    let appeared = null;
    panels.forEach((p) => {
        if (targetId && p.id === targetId) {
            if (p.hidden)
                appeared = p;
            p.hidden = false;
        }
        else {
            p.hidden = true;
        }
    });
    tab.setAttribute('aria-selected', 'true');
    tab.removeAttribute('tabindex');
    if (appeared)
        fadeIn(appeared);
};
export const initTabs = (scope = SELECTORS.container) => {
    resolveContainers(scope).forEach((container) => {
        if (container.hasAttribute(INIT_ATTR))
            return;
        container.setAttribute(INIT_ATTR, '');
        const tabs = Array.from(container.querySelectorAll(SELECTORS.tab));
        const panels = Array.from(container.querySelectorAll(SELECTORS.panel));
        if (!tabs.length)
            return;
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => activateTab(tab, tabs, panels));
            tab.addEventListener('keydown', (e) => {
                const idx = tabs.indexOf(tab);
                const keyMap = {
                    ArrowRight: () => tabs[(idx + 1) % tabs.length],
                    ArrowLeft: () => tabs[(idx - 1 + tabs.length) % tabs.length],
                    Home: () => tabs[0],
                    End: () => tabs[tabs.length - 1],
                };
                const getTarget = keyMap[e.key];
                if (!getTarget)
                    return;
                e.preventDefault();
                const target = getTarget();
                target.focus();
                activateTab(target, tabs, panels);
            });
        });
        const activeTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true') ?? tabs[0];
        activateTab(activeTab, tabs, panels);
    });
};
export default initTabs;
